import React from "react";
import Layout from "../layouts/Layout";
import Logo from "../assets/logo.svg";
import FormInput from "../components/common/FormInput";
import FormSelect from "../components/common/FormSelect";
import Button from "../components/common/Button";
import Footer from "../components/Footer";

const CompetitionRegistration = () => {
  return (
    <>
      <div className="grid grid-cols-2">
        <div className="bg-[rgba(255,102,54,0.1)]">
          <div className="max-w-[670px] w-full pl-24 pt-[34px]">
            <img src={Logo} alt="Steam Minds logo" className="w-[67px]" />

            <h1 className="mt-10 text-[40px] font-bold leading-[56px] my-6 text-black">
              IOI Algorithms
              <br />
              Preparation Guide
            </h1>

            <p className="  leading-5 text-black">Hosted by STEAM Minds</p>

            <div className="mt-20 space-y-[52px] text-2xl leading-5">
              <div className="flex items-center justify-between text-[#050006]">
                <p className=" text-[#938A96]">Starts At;</p>
                <p className="">May 8, 2021 04:30 PM</p>
              </div>

              <div className="flex items-center justify-between text-[#050006]">
                <p className=" text-[#938A96]">Ends At:</p>
                <p>May 8, 2021 04:30 PM</p>
              </div>

              <div className="flex items-center justify-between">
                <p className=" text-[#938A96]">Team Size</p>
                <p>1 Member</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#F5F5F566] shadow-[-4px_0px_6px_-2px_#00000040] pt-28 pb-36 px-12">
          <form className="w-full max-w-[816px]">
            <h2 className="text-[40px] font-bold leading-[56px] text-black">
              Enter your details to complete registration
            </h2>

            <div className="mt-9 flex flex-col gap-y-8">
              <FormInput
                id="student-name"
                label="Student Name"
                type="text"
                placeholder="Student Name"
                inputClassName="mt-[15px] border border-[#938A96]"
              />

              <FormSelect
                id="grade"
                label="Grade"
                placeholder=""
                options={[
                  { label: "Grade 6", value: "grade-6" },
                  { label: "Grade 7", value: "grade-7" },
                  { label: "Grade 8", value: "grade-8" },
                  { label: "Grade 9", value: "grade-9" },
                ]}
                selectClassName="text-base"
              />

              <FormInput
                id="school-name"
                label="School Name"
                type="text"
                placeholder="School Name"
                inputClassName="mt-[15px] border border-[#938A96]"
              />

              <FormInput
                id="phone-no"
                label="Phone Num"
                type="text"
                placeholder="+923190412670"
                inputClassName="mt-[15px] border border-[#938A96]"
              />

              <FormInput
                id="email"
                label="Email"
                type="email"
                placeholder="Email ( Optional)"
                inputClassName="mt-[15px] border border-[#938A96]"
              />
            </div>

            <label className="mt-[60px] flex items-center gap-3 rounded-lg border border-[#938A96] px-2.5 leading-5 py-6  text-black">
              <input
                type="checkbox"
                className="border border-[#938A96] h-5 w-5"
              />
              <span>
                Save my information for Faster Checkout
                <br />
                By Signing Up, you agree to the Terms of Service and Privacy
                Policy. <br /> You Also Agree that you have Parental Consent.
                Important Updates <br /> will be sent via Whatsapp
              </span>
            </label>

            <Button
              btnText={"Complete Registration"}
              btnClassName={
                "mt-12 w-full rounded-lg bg-[#FF6636] text-xl font-medium leading-5 text-white py-[14.5px]"
              }
            />
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CompetitionRegistration;
